export const SUPPLIER_STEPS = [
  '基本資料',
  '資格',
  '聯絡人',
  '交易條件',
  '供應商評估',
  '財務資料',
  '附件',
  '確認',
];

export function supplierWizardStepForField(field: string): number {
  if (/^(contact_|vendor_closing_day|daily_order_cutoff_time)/.test(field)) return 3;
  if (/^(delivery_|freight_|return_)/.test(field)) return 4;
  if (/^(payment_|monthly_|weekly_|invoice_|reconciliation_|bank_|branch_)/.test(field)) return 6;
  return 1;
}
